import { defineComponent, nextTick } from "vue";
import InputText from "../../forms/InputText";
import InputCheckbox from "../../forms/InputCheckbox";
import OrderLayout from "../../layouts/OrderLayout";
import StepBox from "../../components/StepBox";
import Utils from "../../utils/Utils";
import Validator, { ValidationError } from "../../utils/Validator";
import Tracking from "../../utils/Tracking";

export default defineComponent({
    components: {
        InputText,
        InputCheckbox,
        OrderLayout,
        StepBox,
    },

    template: `
        <OrderLayout class="StepCalcForm" :options="options" :step="1" title="Zaczynamy!" @offer:change="onBack">
            <StepBox
                :valid="valid"

                @back="onBack"
                @next="onNext"

            >
                <h2>Dane kontaktowe</h2>

                <InputText label="Imię" v-model="firstname" :required="true" :error="inputError('firstname')" />
                <InputText label="Numer telefonu" v-model="phone" :required="true" :error="inputError('phone')" />
                <InputText label="E-mail" v-model="email" :required="true" :error="inputError('email')" />

                <InputCheckbox :title="termslabel" v-model="terms" />
            </StepBox>
        </OrderLayout>
    `,

    emits: [
        'back',
        'next',
    ],

    props: {
        options: { type: Object, required: true },
    },

    data() {
        return {
            error: null,

            firstname: null,
            phone: null,
            email: null,

            terms: false,
        };
    },

    computed: {
        termslabel() {
            return `Zapoznałem/łam się i akceptuję <a href="/polityka-prywatnosci" target="_blank">Politykę Prywatności</a> i <a href="/regulamin" target="_blank">Regulamin</a> serwisu.`;
        },

        valid() {
            try {
                Validator.assertRequired(this.firstname);
                Validator.assertEmail(this.email);
                Validator.assertPhone(this.phone);
                Validator.assertRequired(this.terms);

                return true;
            } catch (e) {
                return false;
            }
        },
    },


    created() {
        this.setData();
    },

    mounted() {
        nextTick(() => {
            Utils.scrollToEl($('.StepCalcForm'));
        });
    },

    watch: {
        options() {
            this.setData();
        },
    },

    methods: {
        inputError(field: string) {
            try {
                field == 'firstname' && this.firstname && Validator.assertRequired(this.firstname);
                field == 'phone' && this.phone && Validator.assertPhone(this.phone);
                field == 'email' && this.email && Validator.assertEmail(this.email);
            } catch (e) {
                if (e instanceof ValidationError) {
                    return e.message;
                }

                return 'Błędny format pola';
            }
        },

        setData() {
            this.firstname = this.options.billing_firstname;
            this.phone = this.options.phone;
            this.email = this.options.email;
        },

        async onBack() {
            this.$emit('back');
        },

        async onNext() {
            this.error = null;

            await Tracking.doEvent('click_formsubmitted', {
                mail: this.email,
                phone: this.phone,
            });

            try {
                await Utils.setCart('calcform', {
                    usage: this.options.usage,

                    billing_firstname: this.firstname,
                    phone: this.phone,
                    email: this.email,

                    terms: this.terms,
                });

                this.$emit('next');
            } catch (e) {
                console.error(e);
            }
        },
    },
})
